<app-navbar></app-navbar>
<div id="release">
    <div class="container" id="form">
      <div class="title">DevOps Release Notes Form</div>
      <div class="content">

<form action="" (submit)="sendemail()">
    <div class="user-details" style="display: block;">
        <div class="input-box">
          <span class="details">Environment</span>
          <select id="release-environment" name="Environment" [(ngModel)]="releaseinputval.environment">
            <option value="QA">QA</option>
            <option value="Stage">Stage</option>
          </select>
        </div>
        <div class="input-box">
          <span class="details">From Release ID</span>
          <input type="text" placeholder="Enter the Previous Release ID" required id="release-outage" [(ngModel)]="releaseinputval.fromreleaseid" name="fromreleaseid" />
        </div>

        <div class="input-box">
          <span class="details">To Release ID</span>
          <input type="text" placeholder="Enter latest Release ID" required id="release-what" [(ngModel)]="releaseinputval.toreleaseid" name="toreleaseid" />
        </div>
      <div *ngIf="!loading" class="button">
        <input type="submit" value="Download" id="download" />
      </div>
      <div *ngIf="loading" class="loadingbtn">
        <button class="btn btn-primary button" type="button" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Downloading Report...
        </button>
      </div>
      <div id="release-response" *ngIf="statusAvailable">
        <span>LINK:</span>
        {{returndata.data}}
        <span>BUGS:</span>
        {{returndata.response}}
        <br>{{responseMessage}}
      </div>

    </div>
</form>

      </div>
    </div>
  </div>
